import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import CabSearchBar from "../Shared/CabSearchBar";
import CommonSection from "../Shared/CommonSection";
import cabs from "../assest/data/cabs";
import CabCard from "../Shared/CabCard";
import "../styles/cab-booking.css";

const CabBooking = () => {
  // Show featured cabs (top 3 by rating)
  const featuredCabs = [...cabs]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 3);

  return (
    <>
      <CommonSection title="Book a Cab" />
      
      <section className="cab__booking__section">
        <Container>
          <Row>
            <Col lg="12">
              <div className="cab__hero__content">
                <h2>Book Your Ride with Ease</h2>
                <p>
                  Choose from our wide range of comfortable vehicles for your journey.
                  Reliable drivers, competitive prices, and 24/7 availability.
                </p>
                <Link to="/my-cab-bookings">
                  <Button className="my__bookings__btn">
                    <i className="ri-history-line"></i> My Bookings
                  </Button>
                </Link>
              </div>
            </Col>
            <CabSearchBar />
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section className="cab__features__section">
        <Container>
          <Row>
            <Col lg="12">
              <h3 className="section__title">Why Choose Us?</h3>
            </Col>
            <Col lg="3" md="6">
              <div className="feature__box">
                <div className="feature__icon">
                  <i className="ri-shield-check-line"></i>
                </div>
                <h5>Safe & Secure</h5>
                <p>All our drivers are verified and vehicles are sanitized regularly.</p>
              </div>
            </Col>
            <Col lg="3" md="6">
              <div className="feature__box">
                <div className="feature__icon">
                  <i className="ri-wallet-3-line"></i>
                </div>
                <h5>Best Prices</h5>
                <p>Transparent pricing with no hidden charges. Pay only what you see.</p>
              </div>
            </Col>
            <Col lg="3" md="6">
              <div className="feature__box">
                <div className="feature__icon">
                  <i className="ri-time-line"></i>
                </div>
                <h5>24/7 Available</h5>
                <p>Book anytime, anywhere. Our cabs are available round the clock.</p>
              </div>
            </Col>
            <Col lg="3" md="6">
              <div className="feature__box">
                <div className="feature__icon">
                  <i className="ri-customer-service-2-line"></i>
                </div>
                <h5>24/7 Support</h5>
                <p>Our customer support team is always ready to help you.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Cabs Section */}
      <section className="featured__cabs__section">
        <Container>
          <Row>
            <Col lg="12">
              <h3 className="section__title">Popular Vehicles</h3>
              <p className="section__subtitle">Our most booked vehicles with highest ratings</p>
            </Col>
            {featuredCabs.map((cab) => (
              <Col lg="4" md="6" key={cab.id}>
                <CabCard cab={cab} onBookNow={() => {}} />
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CabBooking;
